import service from '@/services/autoQA';

export default {
  loadProductTable: ({ commit, state }) => {
    service
      .getProducts(state.productTable.pagination)
      .then(response => commit('loadProductTableSuccess', response));
  },
  getGeneratedQAForProduct: ({ commit }, productID) => {
    service.getGeneratedQAs(productID).then(response => commit('setGeneratedQAs', response));
  },
  generateQAs: ({ _ }, productID) => {
    service
      .generateQAs(productID)
      .then(() => {})
      .catch(() => {});
  },
  approveQA: (_store, data) => {
    service
      .approveQA(data)
      .then(() => {})
      .catch(() => {});
  },
  rejectQA: ({ _ }, questionID) => {
    service
      .rejectQA(questionID)
      .then(() => {})
      .catch(() => {});
  },
  askQA: ({ _ }, data) => {
    service
      .askQA(data)
      .then(() => {})
      .catch(() => {});
  },
  setPagination({ commit }, payload) {
    return commit('setPagination', payload);
  },
  loadAskedQAs({ commit }, productID) {
    service.getAskedQAs(productID).then(response => commit('setAskedQAs', response));
  },
};
